import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/mA4eGdJuABzhGaQsNzJb9T/Mockup_-_1x1_-_OFN6_-_Epilepsia.webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-66" data-mp="4m8l89fgoljc">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-67" data-mp="12a0j75mcfqrz" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-68" data-mp="x9uqrn89208u">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="-mb-2 -mt-8 font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-69" data-mp="x8b6zmndx72b">
          🌿 BIOMA LÍVIDO™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-5xl font-display text-[21px] font-bold text-white sm:text-5xl lg:text-6xl" data-id="element-70" data-mp="381xkgw128y94">
          Organizá la información actual de tu hijo en 14 días,{' '}
          <span className="text-brand-light" data-id="element-71" data-mp="3e9frdcsh26lo">
            sin tener que revisar años de papeles cada vez.
          </span>
        </motion.h1>

        <div className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-72" data-mp="30gzvcvxzn8u9">
          <img src={mockupUrl} alt="Mockup del Sistema Situación Actual en Orden con sus tres volúmenes y bonos" width="1248" height="1248" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-73" data-mp="358ho4wpuy345" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.25,
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-2xl" data-id="element-74" data-mp="2hjovb94j8bdr">
          <p className="-mb-2 font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-75" data-mp="nbbeh30z0j7e">
            SISTEMA SITUACIÓN ACTUAL EN ORDEN™
          </p>
          <p className="-mb-4 mt-3 text-[13px] text-slate-200 sm:text-base" style={{
          fontSize: "13px"
        }} data-id="element-76" data-mp="ichwoyeni61f">
            El sistema para madres argentinas de hijos con epilepsia refractaria que quieren tener su información actual siempre en orden.
          </p>
          <div className="-mb-5 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-77" data-mp="161jbr4hzoffo">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-78" data-mp="11151dfsx0teh">
              <FileTextIcon className="h-4 w-4 text-brand-light" aria-hidden="true" data-id="element-79" data-mp="x37cyf6yybc5" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-80" data-mp="3hrllolqr8dak">
              <ZapIcon className="h-4 w-4 text-brand-gold" aria-hidden="true" data-id="element-81" data-mp="1xa43fdhjeij3" />
              Acceso en 5 minutos
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.35,
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-7 max-w-lg" data-id="element-82" data-mp="269zi3saawvnv">
          <ActionButton href="#pricing" showTrust data-id="element-83" data-mp="2fz0vrbtdj0yo">
            🧠 QUIERO MI SISTEMA AHORA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}